import dndItemTypes from '../../constants/dndItemTypes'
import SortableWrapperContainer from '../../containers/dnd/SortableWrapperContainer'
import SelectionDisplayContainer from '../../containers/PageProgram/SelectionDisplayContainer'

const MoreElements = ({displaySelections, displaySelectionsOrder, moveSelection}) => (
    <ul>
        {displaySelectionsOrder.map((displaySelectionId, index) => {
            const displaySelection = displaySelections[displaySelectionId]
            
            return (
                displaySelection && displaySelection.type !== 'main' && <li className="more-elements-list-item" key={index}>
                <SortableWrapperContainer 
                    index={index} 
                    moveItem={moveSelection} 
                    dndType={dndItemTypes.SELECTION}>

                    <SelectionDisplayContainer 
                        id={displaySelectionId}
                        displaySelection={displaySelection}
                        displaySelectionsOrder={displaySelectionsOrder}
                        enableDeleteSelection={true}
                    />
                </SortableWrapperContainer>
            </li> 
            )
        })}
    </ul>
)

export default MoreElements